import React, { useState } from "react";
import "../../index.css";
import "../../App.css";
import { Row, Col, Tag, Typography } from "antd";
import { painEntryFormConstants } from "../../helpers/painEntryFormConstants";
import { useSelector, useDispatch } from "react-redux";
import { RootState, AppDispatch } from "./../../redux-toolkit/store/store";
import { handleReliefMethodChange } from "../../redux-toolkit/slices/painEntryFormSlice";

const reliefMethods: string[] = painEntryFormConstants.reliefMethods;

const TeReliefMethods = () => {
  const checkedReliefMethods = useSelector(
    (state: RootState) => state.painEntryForm.reliefMethods
  );
  const dispatch = useDispatch();

  return (
    <div className="flex flex-col gap-2">
      <label className="h6 text-theme-text-secondary">
        <strong>Relief Methods *</strong>
      </label>
      <p className="body1 text-theme-text-primary mb-4">
        Which of these methods help relieve your pain? Understanding what works best for you can help manage your pain more effectively.
      </p>
      <Row gutter={[10, 20]}>
        {reliefMethods.map((reliefMethod) => (
          <Col
            key={reliefMethod}
            xl={6}
            xxl={6}
            lg={6}
            md={8}
            sm={12}
            xs={12}
            style={{ display: "flex" }}
          >
            <Tag.CheckableTag
              checked={checkedReliefMethods.includes(reliefMethod)}
              onChange={() =>
                dispatch(handleReliefMethodChange(reliefMethod))
              }
              className="checkable-tag-pain-entry"
            >
              {reliefMethod}
            </Tag.CheckableTag>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default TeReliefMethods;
